import { useState } from 'react';


const useModal = () => {
  const [showIns, setShowIns] = useState(true);

  function toggleIns() {
    setShowIns(!showIns);
  }

  return {
    showIns,
    toggleIns,
  }
};

export default useModal;